import React from 'react';
import { Select } from 'antd';

const SelectBranch = ({ onChange, branches = [], value, className, required }) => {
    const options = branches.map(b => ({ value: b.id, label: b.name }));

    return (
        <div className={className}>
            <label htmlFor="branchSelector" className="form-label">
                Sede{required ? ' *' : ''}:
            </label>
            <Select
                id="branchSelector"
                className="w-100"
                onChange={onChange}
                options={options}
                value={value || undefined}
                placeholder="Selecciona una sede"
                allowClear
            />
        </div>
    );
};

export default SelectBranch;